type CategoryCardBlobProps = {
  fill: string;
  className?: string;
};

/** Decorative background shape sitting behind a category carousel's heading icon */
const CategoryCardBlob = ({ fill, className }: CategoryCardBlobProps) => (
  <svg
    width="173"
    height="173"
    viewBox="0 0 173 173"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M116.063 1.47163C132.393 5.38294 148.005 14.0635 157.78 27.5324C167.362 40.7358 166.705 57.899 168.708 74.0102C170.758 90.5096 176.709 107.772 169.628 122.86C162.475 138.1 145.666 145.715 131.023 154.304C116.252 162.968 101.364 173.591 84.1861 172.974C66.969 172.356 52.7777 160.815 38.7276 150.992C24.7123 141.192 8.81511 131.892 2.76339 116.044C-3.2435 100.313 1.70937 82.8955 6.57304 66.7859C11.0535 51.9456 18.3266 38.144 29.553 27.3101C40.4982 16.7476 54.5657 10.7016 69.2275 6.3225C84.5609 1.74279 100.494 -2.25742 116.063 1.47163Z"
      fill={fill}
    />
  </svg>
);

export default CategoryCardBlob;
